import axios from '../axios';
import { getApiPath, getConfigPath } from '../utils';
import { getUserInfo } from '../auth';

const baseUrl = getApiPath();
const configUrl = getConfigPath();
const userInfo = getUserInfo();
const elsAccount = userInfo.elsAccount;

/**
 * list materials
 * @param {*} params
 *  * @example
 * // { "elsAccount":"307000" }
 * @returns
 */
const listMaterial = (data) => {
  return axios({
    url: `${baseUrl}/MaterialService/findPageList`,
    method: 'post',
    data
  });
};

const listElsOrgInfo = (action, params) => {
  return axios({
    url: `${baseUrl}/ElsOrgInfoService/${action}`,
    method: 'post',
    data: {
      ...params
    }
  });
};

// 获取 公司 列表
const listPurchaseCompany = (action, params) => {
  Object.assign(params, {
    orgCategoryId: 'companyCode'
  });

  return listElsOrgInfo(action, params);
};

// 获取 工厂 列表
const listPurchaseFactory = (action, params) => {
  Object.assign(params, {
    orgCategoryId: 'factory'
  });

  return listElsOrgInfo(action, params);
};

// 获取 部门 列表
const listPurchaseDeptartment = (action, params) => {
  Object.assign(params, {
    orgCategoryId: 'dept'
  });

  return listElsOrgInfo(action, params);
};

// 获取 采购组 列表
const listPurchaseGroup = (action, params) => {
  Object.assign(params, {
    orgCategoryId: 'purchaseGroup'
  });

  return listElsOrgInfo(action, params);
};

// 获取 采购组织 列表
const listPurchaseOrganization = (action, params) => {
  Object.assign(params, {
    orgCategoryId: 'purchaseOrganization'
  });

  return listElsOrgInfo(action, params);
};

const getPurchaseOranization = (action, params) => {
  return axios({
    url: `${baseUrl}/ElsOrgCategoryService/${action}`,
    method: 'post',
    data: {
      ...params
    }
  });
};

// 获取 供应商主数据 列表
const listSuppliers = (params) => {
  return axios({
    url: `${baseUrl}/supplier/SupplierMasterDataService/findPageList`,
    method: 'post',
    data: {
      elsAccount: elsAccount,
      ...params
    }
  });
};

// 获取 成本中心 列表
const listCostCenter = (params) => {
  return axios({
    url: `${baseUrl}/inquiry/CostCenterRelationService/findPageList`,
    method: 'post',
    data: {
      elsAccount: elsAccount,
      ...params
    }
  });
};

// 获取 价格主数据 列表
const listPriceRecord = (params) => {
  return axios({
    url: `${baseUrl}/inquiry/PurchasePriceRecordsService/findPageList`,
    method: 'post',
    data: {
      elsAccount: elsAccount,
      ...params
    }
  });
};
// 根据物料信息获取价格 POST /PurchasePriceRecordsService/getPriceByMaterialNumber
const getPriceByMaterialNumber = (params) => {
  return axios({
    url: `${baseUrl}/inquiry/PurchasePriceRecordsService/getPriceByMaterialNumber`,
    method: 'post',
    data: {
      ...params
    }
  });
};

// 获取 配置数据 列表
const findElsTemplateConfig = (params) => {
  const url = `${baseUrl}/ElsTemplateConfigService/findPageList`;

  return axios({
    url: url,
    method: 'post',
    data: {
      ...params
    }
  });
};
// 获取 配置数据 详情
const findElsTemplateConfigItem = (item) => {
  const url = `${baseUrl}/ElsTemplateConfigService/getConfig/${item.templateNumer}/${item.templateVersion}`;
  return axios({
    url: url,
    method: 'get'
  });
};

/**
 * 获取 页面数据 列表
 *
 * @param {Object} params - 输入参数
 * @param {string} params.code - 配置平台的列表页配置 code
 * @param {string} params.elsAccount - business account
 * @returns
 */
const findElsPageConfig = (params) => {
  const url = `${baseUrl}/template/TemplateBusinessPageService/findDetail`;
  return axios({
    url: url,
    method: 'post',
    data: {
      ...params
    }
  });
};

// 从配置平台获取页面配置
const findConfigElsPageConfig = (code, businessElsAccount) => {
  const url = `${configUrl}/BusinessPageTemplatesService/no-auth/findDetails/${code}`;
  return axios({
    url: url,
    headers: { businessElsAccount: businessElsAccount },
    method: 'get'
  });
};

const getPurchasePerson = (params) => {
  return axios({
    url: `${baseUrl}/ElsAccountService/findPageList`,
    method: 'post',
    data: {
      ...params
    }
  });
};

const getPurchasePersonBySale = (params) => {
  return axios({
    url: `${baseUrl}/ElsAccountService/findPageListBySale`,
    method: 'post',
    data: {
      ...params
    }
  });
};

const findCreateDeliveryNote = (param) =>
  axios({
    url: `${baseUrl}/order/PurchaseDeliveryNoteService/findCreateDeliveryNote`,
    method: 'post',
    data: { ...param }
  });

const findSaleDeliveryNote = (param) =>
  axios({
    url: `${baseUrl}/order/SaleDeliveryNoteService/findCreateDeliveryManage`,
    method: 'get',
    params: param
  });

const findVoucherNumber = (param) =>
  axios({
    url: `${baseUrl}/order/PurchaseRefundManageService/findReceiptOrder`,
    method: 'post',
    data: { ...param }
  });

const findConfirmedReconCreateInvoice = (param) =>
  axios({
    url: `${baseUrl}/finance/FinanceSaleReconHeadService/findConfirmedReconCreateInvoice`,
    method: 'post',
    data: { ...param }
  });

const findMaterialCate = () =>
  axios({
    url: `${baseUrl}/MaterialCateService/getMaterialCateTree?elsAccount=${elsAccount}`,
    method: 'get'
  });

export const PurchaseDeliveryNoteService = {
  list: findCreateDeliveryNote
};

// 送货通知单
export const SaleDeliveryNoteService = {
  list: findSaleDeliveryNote
};

// 收货单
export const VoucherNumberService = {
  list: findVoucherNumber
};

// 销售方查询对账单
export const ReconNumberService = {
  list: findConfirmedReconCreateInvoice
};

export const ElsAccountService = {
  listEmployee: getPurchasePerson,
  listPurchaseEmployeeBySale: getPurchasePersonBySale
};

export const ElsOrgInfoService = {
  listPurchaseCompany,
  listPurchaseDeptartment,
  listPurchaseFactory,
  listPurchaseGroup,
  listPurchaseOrganization
};

export const ElsOrgCategoryService = {
  getPurchaseOranization
};

export const ElsTemplateConfigService = {
  list: findElsTemplateConfig,
  detail: findElsTemplateConfigItem
};

export const ElsPageConfigService = {
  config: findConfigElsPageConfig,
  list: findElsPageConfig
};

export const MaterialService = {
  list: listMaterial,
  findMaterialCate
};

export const CostCenterRelationService = {
  list: listCostCenter
};

export const PriceRecordService = {
  list: listPriceRecord,
  getPriceByMaterial: getPriceByMaterialNumber
};

export const SupplierMasterDataService = {
  list: listSuppliers
};
